import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { USER_MGMT_CNST } from '../../constants/proj.cnst';
import { UM_TABLE_CNST } from '../../constants/table.cnst';
import { AppStateService } from '../../services/app-state.service';
import { CommonService } from '../../services/common.service';
import { EnvService } from '../../services/env.service';
import { HttpService } from '../../services/http.service';
import { UtilsService } from '../../services/utils.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SkeletonModule } from 'primeng/skeleton';
import { ImportsModule } from '../../modules/imports/imports';
import { ButtonModule } from 'primeng/button';
import { PrimengTableComponent } from '../../modules/shared/components/primeng-table/primeng-table.component';
import { PrimengBreadcrumbComponent } from '../../modules/shared/components/primeng-breadcrumb/primeng-breadcrumb.component';
import { AuthorizationModule } from '../../modules/authorization';
import { SharedModule } from 'primeng/api';
import { SearchFilterPipe } from '../../pipes/search-filter.pipe';
import { TablerIconComponent } from 'angular-tabler-icons';


@Component({
  selector: 'app-applications',
  templateUrl: './applications.component.html',
    standalone: true,
  imports : [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    AuthorizationModule,
    SkeletonModule,
    ImportsModule,
    ButtonModule,
    CommonModule,
    PrimengBreadcrumbComponent,
    RouterModule,
    SearchFilterPipe,
    TablerIconComponent
  ]
})
export class ApplicationsComponent implements OnInit {

  tableConfig: any = {}
  tableData: any = [];
  searchTerm: string = '';
  dataTypes = UM_TABLE_CNST.CLICKABLE_DATA_TYPE;
  modalData: any = [];
  actionNameMapping: any = USER_MGMT_CNST.ACTION_NAME_MAPPING;
  loading: boolean = true;
  first = 0;   
  rows = 10; 

  constructor(
    private commonSrv : CommonService,
    private httpSrv: HttpService,
    private utilSrv: UtilsService,
    private envService : EnvService,
    private router: Router,
    private appStateSrv: AppStateService
  ) { }

  ngOnInit() {
    this.setTableConfig();
    this.setTableData();
  }

  setTableConfig() {
    this.tableConfig = this.commonSrv.setTableConfig('applicationlist')
  }

  setTableData() {
    this.loading = true;
    this.httpSrv.makeGetApiCall('FETCH_ALL_RESOURCES_UNDER_RESOURCE_TYPE', this.envService.baseUrl).subscribe({
      next: (response: any) => {
        let appData = response;
        let applications = Object.keys(appData);
        let tableData = applications.map(app=> {
          let data = {
            applicationName: app,
            resources: this.normalizeResourcesByType(appData[app])
          }
          return data
        });
        this.tableData = tableData;
        this.loading = false;
      },
      complete: () => {},
      error: () => {
        this.utilSrv.showToastMessage("Failed to fetch applications list", "error");
        this.loading = false;
      }
    });
  }

  normalizeResourcesByType(resources: any): any {
    if (!resources || typeof resources !== 'object') {
      return {
        APIs: [],
        URLs: [],
        Dashboards: [],
        Widgets: [],
        Channels: [],
        Others: []
      };
    }

    const knownTypes = USER_MGMT_CNST.RESOURCE_TYPES as string[];
    const normalized: Record<string, any[]> = {};

    for (const type of knownTypes) {
      normalized[type] = Array.isArray(resources[type]) ? [...resources[type]] : [];
    }

    for (const key of Object.keys(resources)) {
      if (knownTypes.includes(key)) {
        continue;
      }
      const items = Array.isArray(resources[key]) ? resources[key] : [];
      if (!items.length) {
        continue;
      }
      if (this.isNullOrUnspecifiedResourceType(key)) {
        normalized['Others'] = [...normalized['Others'], ...items];
      }
    }

    return normalized;
  }

  private isNullOrUnspecifiedResourceType(typeKey: string): boolean {
    if (typeKey == null) {
      return true;
    }
    const normalizedKey = String(typeKey).trim().toLowerCase();
    return !normalizedKey || normalizedKey === 'null' || normalizedKey === 'undefined' || normalizedKey === 'others';
  }

  assignResource(data: any,type: any){
    this.appStateSrv.setApplicationData({info:data,type: type});
    this.router.navigate(['usermgmt','applications','assignResource']);
  }

  onPageChange(event: any) {
    this.first = event.first;   // Index of the first record on the current page
    this.rows = event.rows;     // Number of rows per page
  }

}
